export const selectFiltersListLoading = (store) => store.filterList.loading;
export const selectOperatingAirlines = (store) => store.filterList.operating_airlines;
export const selectJurisdictions = (store) => store.filterList.jurisdictions;
export const selectFiltersListErrors = (store) => store.filterList.errors;
